'use client';

import { useState } from 'react';
import { AddTeamAddressForm } from '../../../AddTeamAddressForm';
import { TeamAgeGroupsForm } from './TeamAgeGroupsForm';
import { TeamCreationForm } from './TeamCreationForm';

export function TeamAddStep(props: {
  onStepSuccess: () => Promise<void> | void;
}) {
  const [step, setStep] = useState<'details' | 'address' | 'age-groups'>(
    'details'
  );
  const [teamId, setTeamId] = useState<number | undefined>(undefined);
  return (
    <div>
      {step === 'details' ? (
        <TeamCreationForm
          onSuccess={(team) => {
            setTeamId(team.id);
            setStep('address');
          }}
        />
      ) : step === 'address' && teamId ? (
        <AddTeamAddressForm
          teamId={teamId}
          onSuccess={() => {
            setStep('age-groups');
          }}
        />
      ) : step === 'age-groups' && teamId ? (
        <TeamAgeGroupsForm teamId={teamId} onSuccess={props.onStepSuccess} />
      ) : null}
    </div>
  );
}
